<template>
  <div id="wrap" class="out">
    <div class="anli_detail_banner">
      <img src="https://www.kingdee.com/news-static/img/anli_detail/banner.png">

      <div class="text">
        <div class="w1000">
          <h2 class="fnt_18 wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">“吴中区三资系统”系统致力于打通资产管理、资产交易、资金支出、
          财务记账的数据壁垒，激活信息价值，确保“三资”数据全面、
          真实、准确，有效避免资产“体外循环”和资金“截留挪用”
          等违规问题。
          </h2>
          <div class="banner-text fnt_16 wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">———吴中区农业农村局农村集体资产管理科科长</div>
        </div>
      </div>

    </div>
    <div class="anli_detail_tag">
      <div class="w1000">
        <div class="anli_tag_text">
          <div class="text">
            <div class="num_list">
              <div class="num_item">
                <div class="fnt_32">
                  <span>多平台融合</span>
                </div>
                <div class="sub_text fnt_14">四网融合</div>
              </div>
              <div class="num_item">
                <div class="fnt_32">
                  <span>超2000人使用</span>
                </div>
                <div class="sub_text fnt_14">吴中区及13个镇村同时使用</div>
              </div>
              <div class="num_item">
                <div class="fnt_32">
                  <span>90%资产线上化</span>
                </div>
                <div class="sub_text fnt_14">纳入三资系统</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="anli_detail_article">
      <div class="w1000">
        <h1>打通多系统数据壁垒，开启“三资”管理新时代</h1>
        <div class="detail_article">
          <div class="anli_item">
            <div class="subtitle fnt_24">客户概述</div>
            <div class="summary fnt_16">
              <p>苏州市吴中区农业农村局是苏州市吴中区机构改革新组建的政府工作部门，根据《苏州市吴中区机构改革方案》将区委农村工作办公室和区农业局（水产局）的职责，以及区发展和改革局的农业投资项目、国土资源部门的农田整治项目、区水利局的农田水利建设项目管理职责等整合，组建区农业农村局，作为区政府工作部门。</p>
            </div>
            <div class="anli_item">
              <div class="subtitle fnt_24">业务挑战</div>
              <div class="summary fnt_16"><p>       为了切实加强农村集体资产管理工作，近年来国家先后发布《国务院关于加强农村集体资产管理工作的通知》、《国务院办公厅关于做好清理化解乡村债务工作的意见》把农村的三资管理工作提升到了新的政治高度。
              集体“三资”监管得好不好，不仅关系到集体资产是否保值增值，群众的利益是否得到维护，更关系到农村基层的政治生态是否风清气正，乡村振兴战略是否能真正落地。多次调研中群众反馈“村级集体资产租赁存在合同不规范、租期过长、租金收缴滞后等问题，个别行政村还有多年租金未收回等问题”，严重影响基层群众获得感。村级财务预算是集体“三资”规范管理中的重要一环，也是农村党风廉政建设的一项重点工作，随着村级经济规模增大，城市化快速推进，不少村（社区）在财务收支管理上缺乏较好的政策规范，传统的财务结算方式已经滞后于集体经济发展所需，“脚踏西瓜皮、滑到哪里算哪里”的现象比较普遍，急需一套切实可行的财务预算制度加以约束。为此，吴中区农业农村局通过睿泽信息技术公司充分利用大数据监督和区块链科技优势，打通信息孤岛，将市交易系统、区集体资产管理系统、村级资金监管平台、财务记账系统和阳光村务平台进行贯通，确保所有村(社区)集体经济组织资金收支按照规范流程开展审批业务，并按照统一设置的会计科目进行财务核算，集体资产租金收缴和银行资金流水全面关联，实现集体资金“全留痕线上审批+全过程线上结算+全方位线上监管”，从源头上杜绝集体资产“体外循环”、集体资金“截留挪用”情况的发生。

              </p></div>
            </div>
            <div class="anli_item">
              <div class="subtitle fnt_24">解决方案</div>
              <div class="summary fnt_16"><p>苏州市吴中区区纪委监委会同区农业农村局携手苏州睿泽信息技术有限公司，将原有的“三资”监管系统进行功能整合和应用优化，升级打造集业务办理、日常管理和监督预警为一体的“四网融合”系统，实现对“三资”监管一网覆盖、一网通办、一网统管，避免资产“体外循环”和资金“截留挪用”等违规问题。借助信息技术建立监督模型，通过数据分析运算，对上链数据进行交叉验证，实现对违规问题的快速捕捉、自动预警。该系统设置20个预警规则，以智能合约实现全要素监督,对违规操作的账户和不良资产实时监控报警，并对所有参与“三资”管理的人员、组织设立区块账户，实现对资产存量、结构、变动、立项、招投标、合同签订、收付款等“三资”业务全周期、全过程监管。</p></div>
            </div>
            <div class="anli_item">
              <h2>“四网融合”推动“三资”智慧监管</h2>
              <div class="summary fnt_16"><p>通过数据深度融合，实现平台互联互通，构建监督模型，打造链上火眼金睛，通过功能的升级实现数据的整合“四网融合”系统充分运用大数据手段，开展全流程监督、嵌入式监督，对“三资”问题进行实时、动态监管，为主动监督、精准监督提供数据支撑，有效提升监督效率和发现问题能力。</p></div>
            </div>
            <div class="anli_item">
              <div class="subtitle fnt_24">客户价值</div>
              <div class="summary fnt_16">
              <p>苏州市吴中区农业农村局，携手睿泽通过“四网融合”升级换代全新的“三资”农村管理系统，逐步统一了农村集体资产监管交易服务平台、区集体资产管理平台、村级集体资金审批平台、财务记账系统等监管平台，实现了资产交易、资产管理、财务核算、资金收支等审批业务线上流转、全程留痕、全面监管，减少了人工录入、核算成本，大大提高了工作效率。“四网融合”系统充分运用大数据手段，开展全流程监督、嵌入式监督，对“三资”问题进行实时、动态监管，为主动监督、精准监督提供数据支撑，有效提升监督效率和发现问题能力，创造了不可替代的价值。</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CircleBtn @back="back" />
  </div>
</template>

<script>
import CircleBtn from '@/components/CircleBtn.vue'

export default {
  name: 'Successcase1',
  components: { CircleBtn },

  data() {
    return {
    }
  },
  mounted() {
    document.querySelector('#wrap').scrollIntoView(true)
  },

  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
}
.out {
  padding-bottom: 50px;
}
.anli_detail_banner {
    position: relative;
    overflow: hidden;
}
.anli_detail_banner img {
    width: 100%;
}
@media only screen and (max-width: 1366px){
.anli_detail_banner .text {
    top: 50%;
}
}
.anli_detail_banner .text {
    position: absolute;
    width: 100%;
    position: absolute;
    top: 55%;
    left: 0;
    transform: translateY(-50%);
    color: #fff;
    text-align: left;
}
.w1000 {
    width: 1000px;
    margin: 0 auto;
    max-width: 94%;
}
.anli_detail_banner .text h2 {
    margin-bottom: 28px;
    width: 65%;
    line-height: 1.88em;
    padding: 0 25px;
}
.anli_detail_banner .text .banner-text {
    margin-bottom: 44px;
    line-height: 1.7em;
    padding: 0 25px;
}
.anli_detail_banner .text h2:before {
    content: "";
    display: block;
    width: 41px;
    height: 34px;
    background: url(../../../assets/yinhao.png);
    opacity: 0.3;
    margin-bottom: 8px;
}
.fnt_18 {
    font-size: 18px;
}
.anli_detail_tag {
  text-align: left;
}
.anli_detail_tag .anli_tag_text {
    padding: 25px;
    background: #fff;
    font-size: 0;
    box-shadow: 1px 1px 20px 5px rgb(0 132 246 / 20%);
    transform: translateY(-50%);
}
.anli_detail_tag .anli_tag_text .img {
    /* padding: 10px; */
    border: 1px solid #eeeeed;
    display: inline-block;
    vertical-align: middle;
}
.anli_detail_tag .anli_tag_text .text {
    display: inline-block;
    vertical-align: middle;
    width: calc(100% - 60px);
    margin-left: 30px;
    margin-right: 30px;
    color: #888888;
}
.anli_detail_tag .anli_tag_text .img img {
    width: 114px;
}
.anli_detail_tag .anli_tag_text .img .img_mobil {
    display: none;
}
.anli_detail_tag .anli_tag_text .title {
    margin-bottom: 8px;
}
.fnt_16 {
    font-size: 16px;
}
.anli_detail_tag .anli_tag_text .title span:first-child {
    font-weight: 600;
    color: #333333;
    margin-right: 20px;
}
.anli_detail_tag .anli_tag_text .text a {
    color: #888888;
}
@media only screen and (max-width: 1440px){
.fnt_24 {
    font-size: 20px;
}
}
.fnt_24 {
    font-size: 24px;
}
.num_list {
    font-size: 0;
    padding: 2.1% 0;
    text-align: center;
}
.num_item {
    display: inline-block;
    width: 33%;
    color: #888888;
    text-align: center;
    position: relative;
    vertical-align: top;
    padding: 0 10px;
}

.fnt_14 {
    font-size: 14px;
}
.num_item .fnt_32 {
    font-weight: 600;
    color: #0084f6;
}
@media only screen and (max-width: 1440px) {
.fnt_32 {
    font-size: 24px;
}
}
.anli_detail_article {
  text-align: left;
}
h2 {
  margin-bottom: 20px;
  font-size: 28px;
  line-height: 40px;
}
.subtitle {
    color: #2386ee;
    margin-bottom: 20px;
}
.fnt_24 {
    font-size: 24px;
}
.fnt_16 {
    font-size: 16px;
}
.summary p {
    margin-bottom: 1.5em;
    line-height: 2em;
    font-size: 15px;
}
h1 {
  font-size: 30px;
  text-align: center;
  margin-bottom: 10px;
}
.num_item:after {
    content: "";
    width: 1px;
    height: 80px;
    background: #e6e6e6;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}
.num_item:last-child:after{display: none;}
</style>>



// WEBPACK FOOTER //
// src/views/successcase/components/Assets.vue